import React from 'react';
import Overlay from 'Components/Overlay';
import Input from 'Components/Input/index';
import Cx from 'classnames';

const preBidPopup = (props) => ( 
    <Overlay>
        <div className="bg-light-blue box-shadow ph-20 pv-20 br-5 tCenter">
            {/* <div className="mb-10 tCenter fSemibold fs-20 mt-10 mb-10">
                {'Pre Bid'} 
            </div> */}
            <div className='tCenter mt-10'>
                <div className="fs-16 pl-20 pv-10 fBold header-medium-color">Enter Pre Bid RFQ Number</div>
                <Input onChange={props.onChange} value={props.value} name="preBidRfqNumber" placeholder="" className="col-1 fs-14"/>
            </div>
            <div className="col-1 ht-60 flex flex-middle flex-center">
                <button className="ht-40 br-5 theme-color border-theme fs-18 fBold wt-150 mr-30" onClick={props.onCancel}>Cancel</button>
                <button className={Cx("ht-40 br-5 theme-color border-theme fs-18 fBold wt-150 mr-30", {'notselectable': !props.value})} onClick={props.onSave}>Save</button>
            </div>
        </div>
    </Overlay>
);

export default preBidPopup;